import { render, staticRenderFns } from "./user-profile.vue?vue&type=template&id=331871fe&scoped=true&"
import script from "./user-profile.vue?vue&type=script&lang=js&"
export * from "./user-profile.vue?vue&type=script&lang=js&"
import style0 from "./user-profile.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./user-profile.vue?vue&type=style&index=1&id=331871fe&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331871fe",
  null
  
)

export default component.exports